import { ISlugDictionary } from '@/dictionaries/utils/slugs/types';

function checkForVillagePageLocation(pathnameSplit: string) {
  const villageRef = ['villen', 'villas', 'ville'];

  return villageRef.includes(pathnameSplit);
}

function checkForExperiencePageLocation(slug: string) {
  const expRef = ['experiences', 'esperienze', 'erfahrungen'];

  return expRef.includes(slug);
}

export const translatePathname = (
  pathname: string,
  locale: string,
  dict: ISlugDictionary,
  selectedValue: string,
) => {
  try {
    const slugs = pathname.split('/');
    const isSameLocale = locale === selectedValue;
    const slugHasLocale = slugs[1].length === 2;

    const atVillagePage = checkForVillagePageLocation(slugs[3]);
    const atExperiencePage = checkForExperiencePageLocation(slugs[3]);

    const expSlugs = localStorage.getItem('expSlugs') as string;
    const parsedSlug = JSON.parse(expSlugs);

    if (slugHasLocale && !isSameLocale) {
      const slugOne = dict['slugOne'][locale][slugs[2]];
      const slugTwo = dict['slugTwo'][locale][slugs[3]];
      const slugThree = dict['slugThree'][locale][slugs[4]];
      const slugFour: string = dict['slugThree'][locale][slugs[5]];

      if (locale !== 'en' && slugs.length === 3) {
        return `/${locale}/${slugOne}`;
      }
      if (locale === 'en' && slugs.length === 3) {
        return `/${slugOne}`;
      }

      if (locale !== 'en' && slugs.length === 4) {
        return `/${locale}/${slugOne}/${slugTwo}`;
      }
      if (locale === 'en' && slugs.length === 4) {
        return `/${slugOne}/${slugTwo}`;
      }

      if (locale !== 'en' && slugs.length === 5) {
        if (atVillagePage) {
          return `/${locale}/${slugOne}/${slugTwo}/${slugs[4]}`;
        } else {
          return `/${locale}/${slugOne}/${slugTwo}/${slugThree}`;
        }
      }
      if (locale === 'en' && slugs.length === 5) {
        if (atVillagePage) {
          return `/${slugOne}/${slugTwo}/${slugs[4]}`;
        } else {
          return `/${slugOne}/${slugTwo}/${slugThree}`;
        }
      }

      if (locale !== 'en' && slugs.length === 6) {
        if (atExperiencePage) {
          return `/${locale}/${slugOne}/${slugTwo}/${slugThree}/${parsedSlug[locale]}`;
        } else {
          return `/${locale}/${slugOne}/${slugTwo}/${slugThree}/${slugFour}`;
        }
      }
      if (locale === 'en' && slugs.length === 6) {
        if (atExperiencePage) {
          return `/${slugOne}/${slugTwo}/${slugThree}/${parsedSlug[locale]}`;
        } else {
          return `/${slugOne}/${slugTwo}/${slugThree}/${slugFour}`;
        }
      }
    } else {
      return pathname;
    }
  } catch (error) {
    if (error instanceof Error) {
      console.log(`JSPERROR:110:${error.message}`);
    } else {
      console.log('JSPERROR:110', error);
    }
  }
};

export const translateMissingLocale = (
  pathname: string,
  locale: string,
  dict: ISlugDictionary,
  selectedValue: string,
) => {
  const slugs = pathname.split('/');
  const isSameLocale = locale === selectedValue;

  if (dict && !isSameLocale) {
    const slugOne: string = dict['slugOne'][locale][slugs[1]];
    const slugTwo: string = dict['slugTwo'][locale][slugs[2]];
    const slugThree: string = dict['slugThree'][locale][slugs[3]];
    const slugFour: string = dict['slugThree'][locale][slugs[4]];

    if (slugs.length === 2) {
      return {
        slugOne,
      };
    }
    if (slugs.length === 3) {
      return {
        slugOne,
        slugTwo,
      };
    }
    if (slugs.length === 4) {
      const atVillagePage = checkForVillagePageLocation(slugs[2]);

      if (atVillagePage) {
        return {
          slugOne,
          slugTwo,
          slugThree: slugs[3],
        };
      } else {
        return {
          slugOne,
          slugTwo,
          slugThree,
        };
      }
    }
    if (slugs.length === 5) {
      try {
        const atExperiencePage = checkForExperiencePageLocation(slugs[2]);

        const expSlugs = localStorage.getItem('expSlugs') as string;
        const parsedSlug = JSON.parse(expSlugs);

        if (atExperiencePage) {
          return {
            slugOne,
            slugTwo,
            slugThree,
            slugFour: parsedSlug[locale],
          };
        } else {
          return {
            slugOne,
            slugTwo,
            slugThree,
            slugFour,
          };
        }
      } catch (error) {
        if (error instanceof Error) {
          console.log(`JSPERROR:111:${error.message}`);
        } else {
          console.log('JSPERROR:111', error);
        }
      }
    }
  }
};
